import React, { useRef, useCallback, useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import { Info } from '@material-ui/icons';


import { isArray, isEmpty, isNull, isUndefined, first, filter } from 'lodash';
import * as Yup from 'yup';


import { Tooltip, IconButton } from '@material-ui/core';

import { Form, Input, Autocomplete } from '~/components/Form';
import { t } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

const theme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "1.4rem",
      },
    }
  }
});


export default function Transferencia({ data, sending, close }) {
  const formRef = useRef(null);

  const userPerfil = useSelector((state) => state.user)

  const [initials, setInitials] = useState(data);

  const [balance, setBalance] = useState(0);
  const [product, setProduct] = useState(0);
  const [unity, setUnity] = useState({});

  const [editorProfileUnidDest, setEditorProfileUnidDest] = useState({});
  const [editorProfileUnidOrigem, setEditorProfileUnidOrigem] = useState({});

  const handleValidJustificativa = useCallback((value) => {

    const regex1 = /[('")]/;

    if (regex1.test(value)) {
      return false;
    }
    return true;

  }, [])


  const handleSubmit = useCallback(
    async (dataForm) => {
      try {

        if (balance === 0) {
          toast.error('O saldo a distribuir é igual a zero!');
          return;
        }


        const schema = Yup.object().shape({
          unid_nome: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')
            ),
          unidade_origem: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')
            ),
          prod_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')
            ),
          cota: Yup.number()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(0, t('s.geral.validacao.tamanhominimo').replace('%s', 0))
            .max(
              balance,
              t('s.geral.validacao.tamanhomaximo').replace('%s', balance)
            ),
          coun_justificativa: Yup.string()
            .max(300, t('s.geral.validacao.tamanhomaximo').replace('%s', 300))
            .test('Teste caracteres', 'Caractere(s) inválido(s)', (value) => handleValidJustificativa(value))
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });

        if (balance === 0) {
          toast.error('O saldo a distribuir é igual a zero!');
          return;
        }

        if (dataForm.cota === 0) {
          toast.error('O saldo a transferir é igual a zero!');
          return;
        }


        
        if (!isUndefined(editorProfileUnidDest) && !isEmpty(editorProfileUnidDest) ){
          if (editorProfileUnidDest.usua_login_rep_cota_unid_perf_tipo !== 4) {
            toast.error('Unidade de destino bloqueada pelo ' + editorProfileUnidDest.usua_login_rep_cota_unid_perf_descricao );
            return;
          }
        }

        if  (!isUndefined(editorProfileUnidOrigem) && !isEmpty(editorProfileUnidOrigem) ) {
          if (editorProfileUnidOrigem.usua_login_rep_cota_unid_perf_tipo !== 4) {
            toast.error('Unidade de origem bloqueada pelo ' + editorProfileUnidOrigem.usua_login_rep_cota_unid_perf_descricao );
            return;
          }
        }

        const dataSendForm = {
          orga_codigo_origem: unity.orga_codigo,
          unid_codigo_origem: unity.unid_codigo,
          orga_codigo_destino: data.unidade.orga_codigo,
          unid_codigo_destino: data.unidade.unid_codigo,
          usua_login: unity.usua_login,
          prod_codigo: dataForm.prod_codigo,
          cota: dataForm.cota,
          coun_justificativa: dataForm.coun_justificativa,
          usua_login_rep_cota_unid: userPerfil.profile.glousuariologin
        };

        await api.put('cotaunidade/transferencia', dataSendForm);

        toast.success('Atualizado com sucesso!');

        setInitials({});

        await close();
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);
        }
      }
    },
    [data, unity, balance, editorProfileUnidDest, editorProfileUnidOrigem]
  );

  const handleGetBalance = useCallback(async () => {
    try {
      if (!isUndefined(unity.unid_codigo)) {
        const response = await api.get(
          `cotaunidade/${unity.unid_codigo}/${unity.orga_codigo}/${product}`
        );
        if (!isEmpty(response.data)) setBalance(response.data.coun_cota);
        else setBalance(0);
      } else {
        setBalance(0);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data, product, unity]);

  const handleCheckProfileOrigem = useCallback((values) => {
    //setDisableActions(values.disable)
    setEditorProfileUnidOrigem(values)
  }, [])
 

  const handleGetAPIUnity = useCallback(async (id, organ) => {
    try {
      const response = await api.get(`unidades/pesquisaunidade/${id}/${organ}`);

      if (!isEmpty(response.data)) {

        if (!isUndefined(response.data) && product) {
          let isBlocked;
          let obj = filter(response.data.cotas, { usua_login_rep_cota_unid_perf_codigo: '2' });
          if (!isEmpty(obj)) {
            const isTimeBlock = first(obj);
            isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.usua_login_rep_cota_unid_perf_codigo != 1 && (userPerfil.profile.perf_tipo == 1 || isTimeBlock.usua_login_rep_cota_unid_perf_codigo < userPerfil.profile.perf_tipo);
            handleCheckProfileOrigem({ disable: isBlocked, ...isTimeBlock });
          } else {
            obj = filter(response.data.cotas, { usua_login_rep_cota_unid_perf_codigo: '3' });
            if (!isEmpty(obj)) {
              const isTimeBlock = first(obj);
              isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.usua_login_rep_cota_unid_perf_codigo != 1 && (userPerfil.profile.perf_tipo == 1 || isTimeBlock.usua_login_rep_cota_unid_perf_codigo < userPerfil.profile.perf_tipo);
              handleCheckProfileOrigem({ disable: isBlocked, ...isTimeBlock });
            } else {
              obj = filter(response.data.cotas, { usua_login_rep_cota_unid_perf_codigo: '4' });
              if (!isEmpty(obj)) {
                const isTimeBlock = first(obj);
                isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.usua_login_rep_cota_unid_perf_codigo != 1 && (userPerfil.profile.perf_tipo == 1 || isTimeBlock.usua_login_rep_cota_unid_perf_codigo < userPerfil.profile.perf_tipo);
                handleCheckProfileOrigem({ disable: isBlocked, ...isTimeBlock });
              } else {
                handleCheckProfileOrigem({});
              }
            }
          }
        }


      } else {
        setEditorProfileUnidOrigem({});
      }


    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data, product, unity]);

  useEffect(() => {



    if (product && !isEmpty(unity)) {
      handleGetBalance();

      if (!isUndefined(unity.unid_codigo)) {
        handleGetAPIUnity(unity.unid_codigo, unity.orga_codigo);
      } else {
        setEditorProfileUnidOrigem({});
      }
    } else {


      if (!isUndefined(formRef.current) && !isNull(formRef.current)) {
        limpacota()
      }

      setBalance(0);
    }

    if (!isUndefined(data) && product) {
      let isBlocked;
      let obj = filter(data.cotas, { usua_login_rep_cota_unid_perf_codigo: '2' });
      if (!isEmpty(obj)) {
        const isTimeBlock = first(obj);
        isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.usua_login_rep_cota_unid_perf_codigo != 1 && (userPerfil.profile.perf_tipo == 1 || isTimeBlock.usua_login_rep_cota_unid_perf_codigo < userPerfil.profile.perf_tipo);
        handleCheckProfile({ disable: isBlocked, ...isTimeBlock });
      } else {
        obj = filter(data.cotas, { usua_login_rep_cota_unid_perf_codigo: '3' });
        if (!isEmpty(obj)) {
          const isTimeBlock = first(obj);
          isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.usua_login_rep_cota_unid_perf_codigo != 1 && (userPerfil.profile.perf_tipo == 1 || isTimeBlock.usua_login_rep_cota_unid_perf_codigo < userPerfil.profile.perf_tipo);
          handleCheckProfile({ disable: isBlocked, ...isTimeBlock });
        } else {
          obj = filter(data.cotas, { usua_login_rep_cota_unid_perf_codigo: '4' });
          if (!isEmpty(obj)) {
            const isTimeBlock = first(obj);
            isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.usua_login_rep_cota_unid_perf_codigo != 1 && (userPerfil.profile.perf_tipo == 1 || isTimeBlock.usua_login_rep_cota_unid_perf_codigo < userPerfil.profile.perf_tipo);
            handleCheckProfile({ disable: isBlocked, ...isTimeBlock });
          }
        }
      }
    }

  }, [data, product, unity]);


  const limpacota = useCallback(async () => {
    await formRef.current.setFieldValue('cota', 0);
    formRef.current.setData({ cota: 0 });
  }, [formRef])



  const handleCheckProfile = useCallback((values) => {
    //setDisableActions(values.disable)
    setEditorProfileUnidDest(values)
  }, [])


  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);


  useEffect(() => {

    if (!isUndefined(data)) {

      const obj = data;
      obj.unidade = {
        ...obj.unidade,
        cota: 0.0
      }

      setInitials(
        isUndefined(data) ?
          {} : {
            ...obj,
          });
    }

  }, [data]);

  if (isEmpty(initials)) return 'Carregando...';

  return (
    <Form ref={formRef} onSubmit={handleSubmit} initialData={isUndefined(initials) ? {} : initials.unidade}>
      <S.Wrapper>

        {(product && !isUndefined(editorProfileUnidDest) && !isUndefined(editorProfileUnidDest.usua_login_rep_cota_unid_perf_descricao)) ?
          <MuiThemeProvider theme={theme}>
            <S.infoWrapper>
              <S.iconWrapper>
                <Tooltip placement="left-end"
                  title={`Alterado por: ${editorProfileUnidDest.usua_login_rep_cota_unid_perf_descricao} `}>
                  <IconButton style={{ padding: 2 }} disabled={isNull(editorProfileUnidDest.usua_login_rep_cota_unid_perf_tipo) || editorProfileUnidDest.usua_login_rep_cota_unid_perf_tipo == 'null'}>
                    <Info style={{ height: '20px', width: '20px' }} color={isNull(editorProfileUnidDest.usua_login_rep_cota_unid_perf_tipo) || editorProfileUnidDest.usua_login_rep_cota_unid_perf_tipo == 'null' ? "#000000de" : "secondary"} />
                  </IconButton>
                </Tooltip>
              </S.iconWrapper>
            </S.infoWrapper>
          </MuiThemeProvider>
          :
          ''
        }


        <Input name="unid_nome" label="Unidade Destino" style={{ background: 'rgba(0, 0, 0, 0.05)' }} disabled />

        <Typography display="block">Selecione a Unidade de Origem</Typography>


        {(product && !isUndefined(editorProfileUnidOrigem) && !isUndefined(editorProfileUnidOrigem.usua_login_rep_cota_unid_perf_descricao)) ?
          <MuiThemeProvider theme={theme}>
            <S.infoWrapper>
              <S.iconWrapper>
                <Tooltip placement="left-end"
                  title={`Alterado por: ${editorProfileUnidOrigem.usua_login_rep_cota_unid_perf_descricao} `}>
                  <IconButton style={{ padding: 2 }} disabled={isNull(editorProfileUnidOrigem.perfil_cad) || editorProfileUnidOrigem.perfil_cad == 'null'}>
                    <Info style={{ height: '20px', width: '20px' }} color={isNull(editorProfileUnidOrigem.perfil_cad) || editorProfileUnidOrigem.perfil_cad == 'null' ? "#000000de" : "secondary"} />
                  </IconButton>
                </Tooltip>
              </S.iconWrapper>

            </S.infoWrapper>
          </MuiThemeProvider>
          :
          ''
        }


        <Autocomplete
          name="unidade_origem"
          label="unid_nome"
          title="Unidade Origem"
          url="unidades/usuario"
          unique="unid_nome"
          getValue={(value) => setUnity(value)}
        />

        <Autocomplete
          name="prod_codigo"
          label="prod_display"
          title="Produto"
          url="produtos"
          unique="prod_codigo"
          getValue={({ prod_codigo }) => setProduct(prod_codigo)}
        />

        <Input name="saldo" label="Saldo Distribuir" value={balance} disabled style={{ background: 'rgba(0, 0, 0, 0.05)' }}/>

        {(!isNull(unity.unid_nome) && product) ?
          <Input
            name="cota"
            label="Saldo Transferir"
            type="number"
            disabled={balance === 0}
          />
          : ''}

        {(!isNull(unity.unid_nome) && product) ?
          <Input
            name="coun_justificativa"
            label="Justificativa"
            disabled={false}
            multiline
            rows={4}
          />
          : ''}

      </S.Wrapper>
    </Form>
  );
}

Transferencia.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
